import React from "react";
import { Image as ImageIcon, Calendar, Archive } from "lucide-react";

export const Thumb = ({ src, href, round, alt = "" }) => {
  const cls = round ? "rounded-full" : "rounded-lg";
  const inner = src ? (
    <img src={src} alt={alt} className={`w-14 h-14 object-cover ${cls} border border-ink-700`} />
  ) : (
    <div className={`w-14 h-14 ${cls} bg-ink-900 border border-ink-700 flex items-center justify-center text-zinc-600`}><ImageIcon className="w-5 h-5" /></div>
  );
  if (href) return (
    <a href={href} target="_blank" rel="noreferrer" data-testid="thumb-link" title="Open source in new tab" className="shrink-0 hover:opacity-80 transition-opacity">{inner}</a>
  );
  return <div className="shrink-0">{inner}</div>;
};

export const DateRange = ({ from, to, onFrom, onTo }) => (
  <div className="flex items-center gap-2">
    <Calendar className="w-4 h-4 text-zinc-500" />
    <input type="date" value={from || ""} onChange={(e) => onFrom(e.target.value)} data-testid="date-from" className="bg-ink-800 border border-ink-700 rounded-lg h-9 px-2 text-sm text-zinc-300" />
    <span className="text-zinc-600">–</span>
    <input type="date" value={to || ""} onChange={(e) => onTo(e.target.value)} data-testid="date-to" className="bg-ink-800 border border-ink-700 rounded-lg h-9 px-2 text-sm text-zinc-300" />
  </div>
);

export const ArchivedToggle = ({ archived, onToggle }) => (
  <button onClick={onToggle} data-testid="archived-toggle"
    className={`h-9 px-3 rounded-lg text-sm font-medium border flex items-center gap-1.5 ${archived ? "bg-brand text-ink-900 border-brand" : "bg-ink-800 text-zinc-300 border-ink-700"}`}>
    <Archive className="w-4 h-4" /> {archived ? "Viewing archived" : "Active"}
  </button>
);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");

export const TabBar = ({ tabs, value, onChange, counts, testidPrefix }) => (
  <div className="flex flex-wrap gap-1 bg-ink-800 border border-ink-700 p-1 rounded-2xl">
    {tabs.map((t) => (
      <button key={t} onClick={() => onChange(t)} data-testid={`${testidPrefix}-${t.toLowerCase().replace(/\s+/g, "-")}`}
        className={`rounded-xl px-3 py-2 text-sm font-medium transition-colors ${value === t ? "bg-brand text-ink-900" : "text-zinc-300 hover:bg-ink-700"}`}>
        {t} <span className="opacity-70 text-xs">({counts[t] || 0})</span>
      </button>
    ))}
  </div>
);

export const Row = ({ children, testid }) => (
  <div data-testid={testid} className="flex items-center gap-4 bg-ink-800 border border-ink-700 rounded-xl p-3 hover:border-ink-600 transition-colors">
    {children}
  </div>
);
